var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ml-1",attrs:{"variant":"advance"}},[_c('b-badge',{attrs:{"varient":"advance"}},[_vm._v(" M ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }